const setLoading = (isLoading) => ({
  type: 'SET_LOADING',
  isLoading,
})

export default setLoading